import { gql } from '@apollo/client';

// --- Per-entity search queries (Atlas Search autocomplete + fuzzy) ---

export const SEARCH_SCHEDULES = gql`
  query SearchSchedules($teamId: String, $input: SearchInput!) {
    searchSchedules(teamId: $teamId, input: $input) {
      _id
      name
      teamId
      path
      tags
      defaultAssetId
      createdAt
      lastUpdatedDate
      parentGroupInfo {
        _id
        name
        path
        teamId
        isFolderSecurityEdit
        isFolderSecurityView
        securities {
          userId
          role
        }
        securityTeams
      }
    }
  }
`;

export const SEARCH_DEVICES = gql`
  query SearchDevices($teamId: String, $input: SearchInput!) {
    searchDevices(teamId: $teamId, input: $input) {
      _id
      UUID
      deviceName
      name
      accountId
      teamId
      path
      lastHeartBeat
      status
      os
      device
      model
      platform
      currentType
      currentAssetId
      currentPlaylistId
      currentScheduleId
      currentSelectionDate
      scale
      orientation
      tags
      muted
      activationDate
      creationDate
      location {
        coordinates
        name
      }
      feature
      temporarily
      scheduleGoLive
      recentAssignments
      assignItem {
        key
        value
        type
      }
      isContentExpired
      parentGroupInfo {
        _id
        name
        path
        teamId
        isFolderSecurityEdit
        isFolderSecurityView
        securities {
          userId
          role
        }
        securityTeams
      }
    }
  }
`;

export const SEARCH_ASSETS = gql`
  query SearchAssets($teamId: String, $input: SearchInput!) {
    searchAssets(teamId: $teamId, input: $input) {
      _id
      name
      type
      fileType
      appType
      webType
      youtubeType
      commonType
      subType
      serviceType
      originalFileName
      thumbnail
      bucket
      AWSS3ID
      path
      groupId
      teamId
      tags
      status
      engage
      contentStatus
      num_pages
      createdAt
      lastUpdatedDate
      playlistId
      parentGroupInfo {
        _id
        name
        path
        teamId
        isFolderSecurityEdit
        isFolderSecurityView
        securities {
          userId
          role
        }
        securityTeams
      }
    }
  }
`;

export const SEARCH_PLAYLISTS = gql`
  query SearchPlaylists($teamId: String, $input: SearchInput!) {
    searchPlaylists(teamId: $teamId, input: $input) {
      _id
      name
      teamId
      path
      tags
      color
      createdAt
      lastUpdatedDate
      parentGroupInfo {
        _id
        name
        path
        teamId
        isFolderSecurityEdit
        isFolderSecurityView
        securities {
          userId
          role
        }
        securityTeams
      }
    }
  }
`;

export const SEARCH_GROUPS = gql`
  query SearchGroups($teamId: String, $input: SearchInput!) {
    searchGroups(teamId: $teamId, input: $input) {
      _id
      name
      type
      path
      description
      teamId
      thumbnail
      bucket
      createdAt
      lastUpdatedDate
      isFolderSecurityEdit
      isFolderSecurityView
      securities {
        userId
        role
      }
      securityTeams
      securitiesDetail {
        name
        userId
        role
      }
      securityTeamsDetail {
        name
        _id
      }
      sharedLink
    }
  }
`;

// --- Global search (all entity types in one query) ---

export const GLOBAL_SEARCH = gql`
  query GlobalSearch($teamId: String, $query: String!, $limit: Int) {
    globalSearch(teamId: $teamId, query: $query, limit: $limit) {
      screens {
        _id
        deviceName
        name
        status
        os
        parentGroupInfo {
          _id
          name
          path
          teamId
          isFolderSecurityEdit
          isFolderSecurityView
          securities {
            userId
            role
          }
          securityTeams
        }
      }
      assets {
        _id
        name
        originalFileName
        type
        fileType
        appType
        thumbnail
        parentGroupInfo {
          _id
          name
          path
          teamId
          isFolderSecurityEdit
          isFolderSecurityView
          securities {
            userId
            role
          }
          securityTeams
        }
      }
      playlists {
        _id
        name
        tags
        parentGroupInfo {
          _id
          name
          path
          teamId
          isFolderSecurityEdit
          isFolderSecurityView
          securities {
            userId
            role
          }
          securityTeams
        }
      }
      schedules {
        _id
        name
        type
        tags
        parentGroupInfo {
          _id
          name
          path
          teamId
          isFolderSecurityEdit
          isFolderSecurityView
          securities {
            userId
            role
          }
          securityTeams
        }
      }
      folders {
        _id
        name
        type
        path
        teamId
      }
      feeds {
        _id
        name
        tags
        thumbnail
        categoryIds
        author
      }
      engages {
        _id
        name
        originalFileName
        type
        fileType
        appType
        thumbnail
        parentGroupInfo {
          _id
          name
          path
          teamId
          isFolderSecurityEdit
          isFolderSecurityView
          securities {
            userId
            role
          }
          securityTeams
        }
      }
    }
  }
`;
